const baseStyle = {};
const defaultProps = {
    size: 'md',
    variant: 'outlined'
};
const parts = ['container', 'button', 'content', 'group', 'option'];
const sizes = {
    sm: {
        button: {
            size: 'sm'
        }
    },
    md: {
        button: {
            size: 'md'
        }
    }
};
const variants = {
    outlined: {
        button: {
            hoverBg: 'white',
            activeBg: 'white',
            borderColor: 'grey.60',
            hoverBorderColor: 'grey.60'
        }
    },
    text: {
        button: {
            hoverBg: 'white',
            activeBg: 'white',
            borderColor: 'transparent',
            hoverBorderColor: 'transparent'
        }
    }
};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
